import React from 'react';
import './style.css'

const LoginPageHeading = (props) => {
  const { LoginHeading } = props;
  return (
    <div>
    <h3 className="login-heading" >{LoginHeading}</h3>
     <div className="headre-line"></div>
    </div>
  );
}

export default LoginPageHeading;
